/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polite_Stale_Parakeet_ReviveInputs */

const es_polite_stale_parakeet_revive = /** @type {(inputs: Polite_Stale_Parakeet_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar problema`)
};

const gl_polite_stale_parakeet_revive = /** @type {(inputs: Polite_Stale_Parakeet_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar problema`)
};

const en_polite_stale_parakeet_revive = /** @type {(inputs: Polite_Stale_Parakeet_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report issue`)
};

/**
* | output |
* | --- |
* | "Report issue" |
*
* @param {Polite_Stale_Parakeet_ReviveInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const polite_stale_parakeet_revive = /** @type {((inputs?: Polite_Stale_Parakeet_ReviveInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polite_Stale_Parakeet_ReviveInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_polite_stale_parakeet_revive(inputs)
	if (locale === "en") return en_polite_stale_parakeet_revive(inputs)
	return es_polite_stale_parakeet_revive(inputs)
});